import React, { ReactElement } from 'react';

type IconProps = {
  iconName: string;
  size: 'xs' | 'sm' | 'md' | 'lg';
  color: string;
  isOutlined?: boolean;
};

/**
 * Circle Blue Solid react icon component.
 * @param props - IconProps.
 * @returns A circle icon.
 */
export default function Icon(props: IconProps): ReactElement {
  const { iconName, size, color, isOutlined } = props;
  return (
    <span className={`material-icons${isOutlined ? '-outlined' : ''} text-${size} ${color}`}>
      {iconName}
    </span>
  );
}
